//
// InfiniReel class
//
// Used to create, spin and animate reels
// Contains no logic.
// Set up reels as follows:
//
//    1 - reelmanager.createReel
//    2 - reelmanager.setSymbol to change initial symbols
//
// To use
//
//    1 - Set data using reelmanager.setData(arrayOfSymbolIndexes)
//    2 - reelmanager.startSpin()
//
//

infiniReelTemplate = {};

infiniReelTemplate.accelerationSpin = function (delta) {
    // Calculate new speed based on acceleration
    this.pos -= ((delta / 1000) * this.speedData.currentAccelerationSpeed);
    this.speedData.currentAccelerationSpeed += (this.speedData.accelerationRate * (delta / 1000));

    return Math.floor((this.speedData.currentAccelerationSpeed >= this.spinParams.spinSpeed));
};

infiniReelTemplate.decelerationSpin = function (delta) {
    // Calculate new speed based on acceleration
    this.speedData.decelerationRate = (this.speedData.currentDecelerationSpeed * this.speedData.currentDecelerationSpeed) / (2 * (this.decelerationPos - (1 - this.spinParams.landOffset)));
    this.pos -= ((delta / 1000) * this.speedData.currentDecelerationSpeed);
    this.decelerationPos -= ((delta / 1000) * this.speedData.currentDecelerationSpeed);
    this.speedData.currentDecelerationSpeed -= (this.speedData.decelerationRate * (delta / 1000));

    while (this.pos < 0) {
        this.pos += 1;
        if (this.postInjector.remainingSymbols > 0) {
            // Spinning in remaining symbols, so comes from post injector
            this.getNextSymbolFromInjector(this.postInjector);
        }
    }

    // We add 0.01 as position approaches 0 but will never reach it. This allows us to end spin when it's within 1/100th of a symbol height.
    return Math.floor((this.decelerationPos <= (1 - this.spinParams.landOffset + 0.01) || this.speedData.currentDecelerationSpeed < this.spinParams.landVelocity));
};

infiniReelTemplate.defaultSpin = function (delta) {
    this.pos -= ((delta / 1000) * this.spinParams.spinSpeed);

    var requiredSymbolCount = 0;
    while (this.pos < 0) {
        this.pos += 1;
        ++requiredSymbolCount;
    }

    if (requiredSymbolCount > 0) {
        var injectorRequired = undefined;

        if (this.stateMachine.ActiveStateName === "INFINITE_SPIN") { // Infinite spin, so symbols comes from pre injector
            injectorRequired = this.preInjector;
        } else if (this.postInjector.remainingSymbols > 0) { // Spinning in remaining symbols, so comes from post injector
            injectorRequired = this.postInjector;
            requiredSymbolCount = Math.min(requiredSymbolCount, this.postInjector.remainingSymbols);
        }

        if (injectorRequired !== undefined) {
            for (var i = 0; i < requiredSymbolCount; ++i) {
                this.getNextSymbolFromInjector(injectorRequired);
            }
        }
    }

    if (this.stateMachine.ActiveStateName === "INFINITE_SPIN") {
        // Infinite spin, so symbols comes from pre injector
        return 1;
    } else {
        // Spinning in remaining symbols, so comes from post injector
        return ((this.postInjector.remainingSymbols + this.pos) < (1 + this.spinParams.decelerationDistance - this.spinParams.landOffset));
    }

};

infiniReelTemplate.nudge = function (delta) {
    this.pos -= ((delta / 1000) * (this.spinParams.spinSpeed));
    if (this.pos <= 0) {
        this.getNextSymbolFromInjector(this.preInjector);
        this.pos = 0.9999 - this.spinParams.landOffset / 2;
        this.Props.stateTime = this.spinParams.landAlignTime / 2;
        this.stateMachine.switchState("NUDGE_PULL_BACK");
    }
};

infiniReelTemplate.popAndDrop = function (progress) {

    // Copy from above
    var progRad = Math.sin(Math.PI * 0.5 + Math.PI * 0.5 * progress);
    progRad = 1 - (progress * progress * progress);
    for (var i = 0; i < this.symbolDropDeltas.length; i++) {
        var pos = (i + 0.5) * this.configParams.appertureSpacing;
        pos += ((this.symbolDropDeltas[i] * -this.configParams.appertureSpacing * progRad));
        this.symbolSprites[i].position.setY( pos );
    }
};

infiniReelTemplate.getDefaultConfigParameters = function () {
    var params = {};
    params.appertureHeight = 3;
    params.preappertureSymbols = 1;
    params.postappertureSymbols = 0;
    params.totalAppertureSize = (params.appertureHeight + params.preappertureSymbols + params.postappertureSymbols);

    params.useContainer = {};
    params.useContainer.background = false;
    params.useContainer.child = false;
    params.useContainer.foreground = false;

    params.animationStripWidth = 0;
    params.animationStripHeight = 0;

    params.popAndDropTime = 400;
    params.autoUpdateClipRect = true;

    return params;
};

infiniReelTemplate.getDefaultSpinParameters = function () {
    var params = {};

    // Acceleration and deceleration unit is "number of symbols"
    params.accelerationDistance = 0;
    params.decelerationDistance = 0;


    // Spin speed and land velocity are in symbols per second
    params.spinSpeed = 9;
    params.landVelocity = 0;

    params.useBounceAnimation = true;
    // Land sound
    params.landSound = undefined;

    // Post land animation
    params.landOffset = 0.25;
    params.landAlignTime = 250;

    params.reverseSpin = false;

    return params;
};


infiniReelTemplate.setSpinParameters = function (params, json) {
    params.spinSpeed = (typeof(json.spinSpeed) !== "undefined") ? json.spinSpeed : params.spinSpeed;
    params.landVelocity = (typeof(json.landVelocity) !== "undefined") ? json.landVelocity : params.landVelocity;
    params.accelerationDistance = (typeof(json.accelerationDistance) !== "undefined") ? json.accelerationDistance : params.accelerationDistance;
    params.decelerationDistance = (typeof(json.decelerationDistance) !== "undefined") ? json.decelerationDistance : params.decelerationDistance;
    params.landOffset = (typeof(json.landOffset) !== "undefined") ? json.landOffset : params.landOffset;
    params.landAlignTime = (typeof(json.landAlignTime) !== "undefined") ? json.landAlignTime : params.landAlignTime;
    params.useBounceAnimation = (typeof(json.useBounceAnimation) !== "undefined") ? json.useBounceAnimation : params.useBounceAnimation;
    params.landSound = (typeof(json.landSound) !== "undefined") ? json.landSound : params.landSound;
    params.reverseSpin = (typeof(json.reverseSpin) !== "undefined") ? json.reverseSpin : params.reverseSpin;
    params.renderSymbolsOutOfView = (typeof(json.renderSymbolsOutOfView) !== "undefined") ? json.renderSymbolsOutOfView : params.renderSymbolsOutOfView;

    if (Reflex.developerModeData.fastSpin) {
        params.spinSpeed = 9999;
        params.accelerationDistance = 0;
        params.decelerationDistance = 0;
        params.landAlignTime = 50;
    }

    return params;
};

infiniReelTemplate.createReel = function (reelIndex, json) {

    // Create reel object
    var reel = new PIXI.Container();
    reel._stateData = {};

    reel.symbolData = [];
    reel.symbolSprites = [];
    reel.workingContainer = {};

    reel.reelIndex = reelIndex;
    reel.spinning = false;
    reel.pos = 0;
    reel.preDelay = 0;

    reel.symbolDropDeltas = [];

    reel.linkedAnimations = [];
    reel.linkedReelBoxStrips = [];

    // The symbols template tells us all about the reel symbols
    var symbolTemplate = resourceManager.getConfiguration().symbols;
    var keys = Object.keys(symbolTemplate);

    // Get configuration parameters used for this template (cant change)
    reel.configParams = infiniReelTemplate.getDefaultConfigParameters();
    if (typeof(json.appertureHeight) !== "undefined") {
        reel.configParams.appertureHeight = json.appertureHeight;
    }
    if (typeof(json.preappertureSymbols) !== "undefined") {
        reel.configParams.preappertureSymbols = json.preappertureSymbols;
    }
    if (typeof(json.postappertureSymbols) !== "undefined") {
        reel.configParams.postappertureSymbols = json.postappertureSymbols;
    }
    if (typeof(json.popAndDropTime) !== "undefined") {
        reel.configParams.popAndDropTime = json.popAndDropTime;
    }

    if (typeof(json.autoUpdateClipRect) !== "undefined") {
        reel.configParams.autoUpdateClipRect = json.autoUpdateClipRect;
    }


    reel.configParams.totalAppertureSize = (reel.configParams.preappertureSymbols + reel.configParams.appertureHeight + reel.configParams.postappertureSymbols);

    // Create spin parameters used for this reel (can change)
    reel.spinParams = infiniReelTemplate.setSpinParameters.bind(reel)(infiniReelTemplate.getDefaultSpinParameters(), json);

    var symbolTextures = textureParser.getTextureList("staticSymbols");
    var initialSymbols = [];
    for (var i = 0; i < reel.configParams.totalAppertureSize; ++i) {
        initialSymbols.push({
            symbolId: 0
        });
    }

    // Create object to store all speed parameters neatly
    reel.speedData = {};
    reel.symbolLUT = {};

    // Create look up table
    for (var i = 0; i < keys.length; i++) {
        var symbolDef = symbolTemplate[keys[i]];
        reel.symbolLUT["ID" + symbolDef.ID] = i;
    }

    reel.saveState = function() {
        this._stateData = {};
        var keys = Object.getOwnPropertyNames(this);
        var keysToIgnore = Object.keys(new PIXI.Container());

        // These are all PIXI objects
        keysToIgnore.push("symbolSprites");
        keysToIgnore.push("linkedAnimations");
        keysToIgnore.push("linkedReelBoxStrips");
        keysToIgnore.push("symbolContainer");
        keysToIgnore.push("interactiveSymbolContainer");
        keysToIgnore.push("animationStripContainer");
        keysToIgnore.push("animationBoxContainer");
        keysToIgnore.push("workingContainer");

        // These arent saved change
        keysToIgnore.push("Props");
        keysToIgnore.push("stateMachine");
        keysToIgnore.push("phase");
        keysToIgnore.push("_stateData");
        keysToIgnore.push("preInjector");
        keysToIgnore.push("postInjector");

        for (var i = 0; i < keysToIgnore.length; i++) {
            keys.splice(keys.indexOf(keysToIgnore[i]), 1);
        }

        for (var i = 0; i < keys.length; i++) {
            var name = keys[i];
            var type = typeof(this[name]);
			var isCallback = (name.includes("callback") || name.includes("Callback"));
			
            if ((type !== "function") && (name !== "base") && !isCallback) {
                if (checkForDefined(this[name])) {
                    this._stateData[keys[i]] = JSON.parse(JSON.stringify(this[name]));
                }
                else {
                    this._stateData[keys[i]] = undefined;
                }
            }
        }
    };

    reel.restoreState = function() {
        var keys = Object.keys(this._stateData);
        for (var i = 0; i < keys.length; i++) {
            var name = keys[i];
            if (checkForDefined(this._stateData[name])) {
                this[name] = JSON.parse(JSON.stringify(this._stateData[name]));
            }
            else {
                this[name] = undefined;
            }
        }

        // Reset symbol sprites
        for (var i = 0; i < this.symbolData.length; i++) {
            this.setReelSymbol(i - reel.configParams.preappertureSymbols, this.symbolData[i]);
        }
        this.stateMachine.switchState("READY");
        this._stateData = {};
    };

    reel.setInjectors = function (preInjector, postInjector) {
        // Use the values from the current preInjector to initialise the new preInjector
        if (checkForDefined(this.preInjector)) {
            preInjector.initialiseInjector({
                reelId: this.reelIndex,
                minimumSymbols: this.preInjector.minimumSymbols,
                spinReversed: this.spinParams.reverseSpin,
                requiredSymbols: this.preInjector.requiredSymbols,
                symbolsLastDrawn: this.preInjector.symbolsLastDrawn
            });
        } else {
            preInjector.initialiseInjector({
                reelId: this.reelIndex,
                minimumSymbols: 0,
                spinReversed: this.spinParams.reverseSpin,
                requiredSymbols: [],
                symbolsLastDrawn: []
            });
        }

        postInjector.initialiseInjector(this.reelIndex);
        // Use the values from the current postInjector to initialise the new postInjector
        if (checkForDefined(this.postInjector)) {
            postInjector.requiredSymbols = this.postInjector.requiredSymbols;
            postInjector.symbolsLastDrawn = this.postInjector.symbolsLastDrawn;
        }

        this.preInjector = preInjector;
        this.postInjector = postInjector;
    };

    reel.infiniteSpin = function (minDistance) {
        // Initialise
        this.preInjector.initialiseInjector({
            reelId: this.reelIndex,
            minimumSymbols: minDistance,
            spinReversed: this.spinParams.reverseSpin,
            requiredSymbols: this.postInjector.requiredSymbols,
            symbolsLastDrawn: this.postInjector.symbolsLastDrawn
        });
        this.postInjector.initialiseInjector(this.reelIndex);

        this.pos = 0.99999;
        this.slamStopRequested = false;

        this.stopRequested = false;
        this.startSpin();
    };

    reel.requestSlamStop = function() {
        this.slamStopRequested = true;
    };

    reel.checkSlamStop = function() {
        if (this.slamStopRequested) {
            // Get all remaining symbol out the injector. Note we dont have to create every symbol, so first dump everything that will go in the apperture
            while (this.postInjector.remainingSymbols > (this.configParams.appertureHeight + this.configParams.preappertureSymbols + this.configParams.postappertureSymbols)) {
                this.postInjector.getNextSymbol(this.symbolData);
            }

            while (this.postInjector.remainingSymbols > 0) {
                this.getNextSymbolFromInjector(this.postInjector);
            }

            // Update positions to rest
            this.pos = 0;
            this.updateSymbols();

            // Go to just landed state to continue
            this.stateMachine.switchState("JUST_LANDED");

            return true;
        };

        return false;
    };

    reel.requestStop = function () {
        this.stopRequested = true;
        this.preInjector.prepareToSplice();
    };

    reel.stop = function (positions, numberPreSymbols) {
        this.stateMachine.switchState("SPINNING");
        this.updatePos = infiniReelTemplate.defaultSpin.bind(this);
    };

    reel.setSpinParameters = function (spinParameters) {
        // spin Parameters should be passed as an object
        infiniReelTemplate.setSpinParameters.bind(this)(this.spinParams, spinParameters);
    };

    reel.spinDeceleratingCallback = function () {
    };
    reel.spinLandedCallback = function () {
    };
    reel.spinCompleteCallback = function () {
    };
    reel.nudgeOnComplete = function () {
    };
    reel.Props = {};

    reel.Props.state = "READY";
    reel.Props.stateTime = 0;

    // Create data
    reel.symbolWidth = symbolTextures[0].width;
    reel.symbolHeight = symbolTextures[0].height;

    // These sizes are in standard layout space
    reelManager.symbolWidth = symbolTextures[0].width;
    reelManager.symbolHeight = symbolTextures[0].height;

    reel.configParams.appertureSpacing = checkForDefined(json.appertureSpacing) ? json.appertureSpacing : reel.symbolHeight;
    reel.configParams.viewportWidth = (checkForDefined(json.viewportWidth) ? (json.viewportWidth / resourceManager.selectedAssetResolution.scaleFactor) : reel.symbolWidth);
    reel.configParams.viewportHeight = (checkForDefined(json.viewportHeight) ? (json.viewportHeight / resourceManager.selectedAssetResolution.scaleFactor) : (reel.configParams.appertureSpacing * reel.configParams.appertureHeight));
    reel.configParams.viewportOffsetX = ((reel.configParams.viewportWidth - reelManager.symbolWidth) / 2);

    if (checkForDefined(json.useContainer)) {
        reel.configParams.useContainer.background = (checkForDefined(json.useContainer.background) ? json.useContainer.background : reel.configParams.useContainer.background);
        reel.configParams.useContainer.child = (checkForDefined(json.useContainer.child) ? json.useContainer.child : reel.configParams.useContainer.child);
        reel.configParams.useContainer.foreground = (checkForDefined(json.useContainer.foreground) ? json.useContainer.foreground : reel.configParams.useContainer.foreground);
    }

    reel.configParams.animationStripWidth = checkForDefined(json.animationStripWidth) ? json.animationStripWidth : reel.configParams.viewportWidth;
    reel.configParams.animationStripHeight = checkForDefined(json.animationStripHeight) ? json.animationStripHeight : reel.configParams.viewportHeight;

    // Set up background
    if (typeof(json.backgroundColour) !== "undefined") {
        var backgroundFill = new PIXI.Graphics();
        backgroundFill.beginFill(json.backgroundColour, 1);
        backgroundFill.drawRect(0, 0, reel.symbolWidth, reel.symbolHeight * reel.configParams.appertureHeight);
        backgroundFill.endFill();
        reel.addChildAt(backgroundFill, 0);
    }

    reel.symbolSize = [];
    reel.initialise = function (json) {
        reel.symbolContainer = resourceManager.createObject("container", "symbolContainer", json.FQN, {
            //Move symbols within clip area
            x: ((reel.configParams.viewportWidth / 2) * resourceManager.selectedAssetResolution.scaleFactor),
            y: 0
        });
        reel.symbolContainer.parent.removeChild(reel.symbolContainer);

        reel.interactiveSymbolContainer = new PIXI.Graphics();
        reel.interactiveSymbolContainer.interactive = true;
        reel.interactiveSymbolContainer.mousedown = function (eventData) {
            //Convert the mouse position to be relative to the reel
            var point = eventData.data.getLocalPosition(this);
            //Get the selected index
            var index = Math.floor(point.y / reel.configParams.appertureSpacing);
            index += reel.configParams.preappertureSymbols;

            //Invoke the mousedown event on the selected symbol
            if (reel.symbolSprites[index].symbol.interactive && (reel.symbolSprites[index].symbol.mousedown !== undefined))
                reel.symbolSprites[index].symbol.mousedown(eventData);
        };
        reel.interactiveSymbolContainer.beginFill(0x000000, 0);
        reel.interactiveSymbolContainer.drawRect(0, 0, reel.configParams.viewportWidth, reel.configParams.viewportHeight);
        reel.addChild(reel.symbolContainer);

        reel.mask = new PIXI.Graphics();
        reel.mask.beginFill(0x000000, 0);
        reel.mask.drawRect(0, 0, reel.configParams.viewportWidth + 1, reel.configParams.viewportHeight + 1);
        reel.mask.endFill();
        reel.addChild(reel.mask);

        for (var i = 0; i < reel.configParams.totalAppertureSize; i++) {
            var newSymbolContainer = resourceManager.createObject("container", ("symbol" + i), reel.symbolContainer.name, {
                x: 0,
                y: ((i + 0.5) * reel.configParams.appertureSpacing),
            });
            newSymbolContainer.index = i;

            if (reel.configParams.useContainer.background) {
                newSymbolContainer.background = resourceManager.createObject("container", "backgroundContainer", newSymbolContainer.name, {
                    x: 0,
                    y: 0
                });
            }

            newSymbolContainer.symbol = resourceManager.createObject("movie", "symbol", newSymbolContainer.name, {
                x: 0,
                y: 0,
                definition: "staticSymbols",
                cloneTextures: true
            });

            if (reel.configParams.useContainer.child) {
                newSymbolContainer.symbol.childContainer = resourceManager.createObject("container", "childContainer", newSymbolContainer.symbol.name, {
                    x: 0,
                    y: 0
                });
            }
            if (reel.configParams.useContainer.foreground) {
                newSymbolContainer.foreground = resourceManager.createObject("container", "foregroundContainer", newSymbolContainer.name, {
                    x: 0,
                    y: 0
                });
            }

            newSymbolContainer.dimReelsCanvas = resourceManager.createObject("graphics", "dimReelsCanvas", newSymbolContainer.name, {
                x: 0,
                y: 0
            });
            newSymbolContainer.dimReelsCanvas.beginFill(0x000000);
            newSymbolContainer.dimReelsCanvas.drawRect(-(reel.configParams.viewportWidth + 1) / 2, -(reel.configParams.viewportHeight + 1) / 2, reel.configParams.viewportWidth + 1, reel.configParams.viewportHeight + 1);
            newSymbolContainer.dimReelsCanvas.endFill();
            newSymbolContainer.dimReelsCanvas.alpha = 0.6;
            newSymbolContainer.dimReelsCanvas.visible = false;

            newSymbolContainer.symbol.anchor.set(0.5, 0.5);
            newSymbolContainer.symbol.gotoAndStop(initialSymbols[i].symbolId);

            reel.symbolData.push(initialSymbols[i]);
            reel.symbolSprites.push(newSymbolContainer);
            newSymbolContainer.symbol.symbolIndex = i;
            newSymbolContainer.symbol.parentReel = reel;

            // Confirm all files loaded
            for (var j = 0; j < newSymbolContainer.symbol.textures.length; j++) {
                if (!newSymbolContainer.symbol.textures[j].baseTexture.hasLoaded) {
                    console.log("Texture index " + j + " for symbol " + Object.keys(resourceManager.getConfiguration().symbols)[j] + " was not loaded");
                    return;
                }
            }

            // Store original UV'. We only do this for the first symbol in the animation movie, as this is the one we spin past.
            if (i === 0) {
                for (var j = 0; j < newSymbolContainer.symbol.textures.length; j++) {
                    reel.symbolSize.push({
                        width: newSymbolContainer.symbol.textures[j].frame.width,
                        height: newSymbolContainer.symbol.textures[j].frame.height
                    });
                }
            }
        }

        for (var i = 0; i < this.symbolData.length; i++) {
            reel.symbolDropDeltas.push(0);
        }


        if (reel.configParams.useContainer.background || reel.configParams.useContainer.child || reel.configParams.useContainer.foreground) {
            // A container to use as temporary storage when adjusting the symbols as part of getNextSymbolFromInjector
            reel.workingContainer = resourceManager.createObject("container", "workingContainer", newSymbolContainer.name, {
                x: 0,
                y: 0
            });
        }

        // A container to hold all of the animation strips for this reel
        reel.animationStripContainer = resourceManager.createObject("container", "animationStripContainer", json.FQN, {
            x: 0,
            y: 0
        });
        reel.animationStripContainer.parent.removeChild(reel.animationStripContainer);
        reel.animationStripContainer.scale.set(1.0, 1.0);

        /*
        reel.animationStripContainer.mask = new PIXI.Graphics();
        reel.animationStripContainer.mask.beginFill(0x000000, 0);
        reel.animationStripContainer.mask.drawRect(-reel.configParams.viewportWidth / 2, 0, reel.configParams.viewportWidth + 1, reel.configParams.viewportHeight + 1);
        reel.animationStripContainer.mask.endFill();
        reel.animationStripContainer.addChild(reel.animationStripContainer.mask);
        */

        // A container to hold all of the animation box strip for this reel
        reel.animationBoxContainer = resourceManager.createObject("container", "animationBoxContainer", json.FQN, {
            x: 0,
            y: 0
        });
        reel.animationBoxContainer.parent.removeChild(reel.animationBoxContainer);
    };

    reel.onTouched = function () {
        this.touchedCallback(this.parentReel.reelIndex, (this.symbolIndex - reel.configParams.preappertureSymbols));
    };

    reel.setTouchCallback = function (index, callback) {
        index += reel.configParams.preappertureSymbols;
        reel.symbolSprites[index].symbol.interactive = true;
        reel.symbolSprites[index].symbol.mousedown = reel.symbolSprites[index].symbol.touchstart = reel.onTouched;
        reel.symbolSprites[index].symbol.touchedCallback = callback;
    };

    reel.clearTouchCallback = function (index) {
        reel.symbolSprites[index + reel.configParams.preappertureSymbols].symbol.interactive = false;
    };

    reel.setReelSymbol = function (index, symbolData) {
        var spriteIndex = (index + reel.configParams.preappertureSymbols);
        this.clearReelSymbolData(spriteIndex);
        this.setReelSymbolData(spriteIndex, symbolData);
        this.pos = 0.99999;
        this.updateSymbols();
        var symbol = this.symbolData[spriteIndex].ID;

        if (reel.anySymbolCreatedCallback !== undefined) {
            reel.anySymbolCreatedCallback(this.reelIndex, symbol, spriteIndex);
        }
        if (reel.symbolCreatedCallbacks[symbol] !== undefined) {
            reel.symbolCreatedCallbacks[symbol](this.reelIndex, symbol, spriteIndex);
        }

    };

    reel.setSymbol = function (index, symbol) {
        index += reel.configParams.preappertureSymbols;
        // Change the symbol and the underlying data
        this.symbolSprites[index].symbol.gotoAndStop(symbol);
        this.symbolData[index].symbolId = symbol;

        if (reel.anySymbolCreatedCallback !== undefined) {
            reel.anySymbolCreatedCallback(this.reelIndex, symbol, index);
        }
        if (reel.symbolCreatedCallbacks[index] !== undefined) {
            reel.symbolCreatedCallbacks[index](this.reelIndex, symbol, index);
        }

    };

    reel.getSymbol = function (index) {
        return this.symbolData[index + reel.configParams.preappertureSymbols].symbolId;
    };

    reel.removeSymbol = function (index) {
        // The index is the symbol in view index
        if (typeof(index) !== "number" || index < 0 || index > this.configParams.appertureHeight - 1) {
            console.error("Invalid index (" + index + ") passed in removeSymbol");
            return;
        }

        // Get the new symbol before we shift the array so that we can apply rules to all current symbols
        var data = this.preInjector.getNextSymbol(this.symbolData);

        if (this.spinParams.reverseSpin) {
            this.symbolData.reverse();
            this.symbolSprites.reverse();
        }

        var removeIndex = this.configParams.preappertureSymbols + index;

        // Tell game to clean up symbols before removing
        var lastSymbolId = this.symbolData[removeIndex].symbolId;
        if (reel.anySymbolDeletedCallback !== undefined) {
            reel.anySymbolDeletedCallback(this.reelIndex, lastSymbolId, removeIndex);
        }
        if (reel.symbolDeletedCallbacks[lastSymbolId] !== undefined) {
            reel.symbolDeletedCallbacks[lastSymbolId](this.reelIndex, lastSymbolId, removeIndex);
        }

        // Remove object
        this.clearReelSymbolData(removeIndex);
        var lastBackground = this.symbolSprites[removeIndex].background;
        var lastChildContainer = this.symbolSprites[removeIndex].symbol.childContainer;
        var lastForeground = this.symbolSprites[removeIndex].foreground;
        resourceManager.setParent(lastBackground, this.workingContainer);
        resourceManager.setParent(lastChildContainer, this.workingContainer);
        resourceManager.setParent(lastForeground, this.workingContainer);

        // Move children down to next index
        for (var i = removeIndex; i > 0; --i) {
            this.symbolData[i] = this.symbolData[i - 1];

            // Update background
            resourceManager.setParent(this.symbolSprites[i - 1].background, this.symbolSprites[i]);
            this.symbolSprites[i].background = this.symbolSprites[i - 1].background;
            if (this.symbolSprites[i].background !== undefined) {
                this.symbolSprites[i].setChildIndex(this.symbolSprites[i].background, 0);
            }
            // Update childContainer
            resourceManager.setParent(this.symbolSprites[i - 1].symbol.childContainer, this.symbolSprites[i].symbol);
            this.symbolSprites[i].symbol.childContainer = this.symbolSprites[i - 1].symbol.childContainer;
            // Update foreground
            resourceManager.setParent(this.symbolSprites[i - 1].foreground, this.symbolSprites[i]);
            this.symbolSprites[i].foreground = this.symbolSprites[i - 1].foreground;

            // If the symbol is oversized then we need to move it to the front
            if (this.symbolData[i].oversized === true) {
                var symbolId = this.symbolSprites[i].symbol;
                var symbolSprite = this.symbolContainer.children.find(function (element) {
                    return (element.symbol === symbolId);
                });
                this.symbolContainer.setChildIndex(symbolSprite, (this.symbolContainer.children.length - 1));
            }

            this.setSymbol(i - this.configParams.preappertureSymbols, this.symbolData[i].symbolId);
        }

        // Remove reference to the now redundant children from the last symbol and move to the first symbol
        resourceManager.setParent(lastBackground, this.symbolSprites[0]);
        this.symbolSprites[0].background = lastBackground;
        if (this.symbolSprites[0].background !== undefined) {
            this.symbolSprites[0].setChildIndex(lastBackground, 0);
        }
        resourceManager.setParent(lastChildContainer, this.symbolSprites[0].symbol);
        this.symbolSprites[0].symbol.childContainer = lastChildContainer;
        resourceManager.setParent(lastForeground, this.symbolSprites[0]);
        this.symbolSprites[0].foreground = lastForeground;

        // Create any child objects
        this.setReelSymbolData(0, data);

        var newSymbolId = ((typeof(data) === 'number') ? data : data.symbolId);
        if (reel.anySymbolCreatedCallback !== undefined) {
            reel.anySymbolCreatedCallback(this.reelIndex, newSymbolId, 0);
        }
        if (reel.symbolCreatedCallbacks[newSymbolId] !== undefined) {
            reel.symbolCreatedCallbacks[newSymbolId](this.reelIndex, newSymbolId, 0);
        }

        if (this.spinParams.reverseSpin) {
            this.symbolData.reverse();
            this.symbolSprites.reverse();
        }

        if (!this.spinParams.renderSymbolsOutOfView) {
            var preClippingIndex = (this.configParams.preappertureSymbols - 1);
            var postClippingIndex = (this.configParams.preappertureSymbols + this.configParams.appertureHeight);
            for (var i = 0; i < this.configParams.totalAppertureSize; ++i) {
                if ((i < preClippingIndex) || (i > postClippingIndex))
                    this.symbolSprites[i].visible = false;
                else
                    this.symbolSprites[i].visible = true;
            }
        }
        return data;

    };

    reel.showSymbol = function (index, show) {
        var symbolSpriteIndex = index + reel.configParams.preappertureSymbols;
        this.symbolSprites[symbolSpriteIndex].symbol.visible = show;
        if (checkForDefined(this.symbolSprites[symbolSpriteIndex].background)) {
            this.symbolSprites[symbolSpriteIndex].background.visible = show;
        }
        if (checkForDefined(this.symbolSprites[symbolSpriteIndex].foreground)) {
            this.symbolSprites[symbolSpriteIndex].foreground.visible = show;
        }
    };

    reel.setSpinner = function (spinnerFunction) {
        this.updatePos = spinnerFunction.bind(this);
    };

    reel.startSpin = function () {
        this.spinning = true;
        this.stateMachine.switchState("PRE_DELAY");
        this.Props.stateTime = this.preDelay;
        this.speedData.accelerationRate = (this.spinParams.spinSpeed * this.spinParams.spinSpeed) / (2 * this.spinParams.accelerationDistance);
        if (this.spinParams.reverseSpin) {
            this.speedData.accelerationRate *= -1;
        }

        this.speedData.currentAccelerationSpeed = 0;
        this.speedData.currentDecelerationSpeed = this.spinParams.spinSpeed;
    };

    reel.nudge = function () {
        this.stateMachine.switchState("NUDGE");
    };

    reel.popSymbols = function(symbolsToPop) {
        // Use dropSymbols after calling popSymbls

        // Note it is up to the game programmer to set the symbols that are dropping in before calling this function
        for (var i = 0; i < this.symbolData.length; i++) {
            this.symbolDropDeltas[i] = 0;
        }

        var symbolsPopped = 0;
        var lastSymbolToPopIndex = this.configParams.preappertureSymbols + symbolsToPop.length - 1;
        for (var i = symbolsToPop.length - 1; i >= 0; --i) {
            if (symbolsToPop[i]) {
                symbolsPopped++;
            }
            else {
                this.symbolDropDeltas[lastSymbolToPopIndex--] = symbolsPopped;
            }
        }

        // Fill in all the above symbols so they are also dropped
        for (var i = 0; i <= lastSymbolToPopIndex; ++i) {
            this.symbolDropDeltas[i] = symbolsPopped;
        }

        for (var i = this.symbolDropDeltas.length - 1; i >= 0; --i) {
            var index = i - this.symbolDropDeltas[i];
            if (index < 0) {
                // Get symbol from injector
                this.setReelSymbol(i - this.configParams.preappertureSymbols, this.preInjector.getNextSymbol(this.symbolData));
            }
            else if (this.symbolDropDeltas[i] > 0) {
                // Copy from above
                this.setReelSymbol(i - this.configParams.preappertureSymbols, this.symbolData[index]);
                this.symbolSprites[i].position.setY((i + 0.5) * this.configParams.appertureSpacing + (this.symbolDropDeltas[i] * -this.configParams.appertureSpacing));
            }
        }
    };

    reel.dropSymbols = function(symbolsToPop, completeCallback) {
        // Use popSymbls before calling dropSymbols
        this.popAndDropComplete = completeCallback;
        this.stateMachine.switchState("POP_AND_DROP");
    };

    reel.popAndDrop = function (symbolsToPop, completeCallback) {
        reel.popSymbols(symbolsToPop);
        reel.dropSymbols(symbolsToPop, completeCallback);
    };


    reel.dimSymbol = function (index, dim, tint) {
        var children;
        if (dim) {
            tint = checkForDefined(tint) ? tint : 0x777777;
        } else {
            tint = 0xFFFFFF;
        }
        // if we are in canvass don't tint show dimReelsCanvas graphic (fix for symbol switching PIXI glich in canvas renderer)
        if (systemData.renderer instanceof PIXI.CanvasRenderer) {
            this.symbolSprites[index].dimReelsCanvas.visible = (tint != 0xFFFFFF);
        } else {
            this.symbolSprites[index].symbol.tint = tint;

            if (checkForDefined(this.symbolSprites[index].background)) {
                children = this.symbolSprites[index].background.children;
                for (var i = 0; i < children.length; i++) {
                    children[i].tint = tint;
                }
            }

            if (checkForDefined(this.symbolSprites[index].foreground)) {
                children = this.symbolSprites[index].foreground.children;
                for (var i = 0; i < children.length; i++) {
                    children[i].tint = tint;
                }
            }

            if (checkForDefined(this.symbolSprites[index].symbol.childContainer)) {
                children = this.symbolSprites[index].symbol.childContainer.children;
                for (var i = 0; i < children.length; i++) {
                    children[i].tint = tint;
                }
            }

        }

    };

    reel.dimAllSymbols = function (dim, tint) {
        for (var i = 0; i < reel.configParams.totalAppertureSize; i++) {
            reel.dimSymbol(i, dim, tint);
        }
    };

    reel.linkAnimation = function (animationStrip, animationStripID) {
        reel.linkedAnimations.push(animationStrip);
        resourceManager.setParent(animationStrip, this.animationStripContainer);
    };

    reel.linkReelBoxStrip = function (animationStrip, animationStripID) {
        reel.linkedReelBoxStrips.push(animationStrip);
        resourceManager.setParent(animationStrip, this.animationBoxContainer);
    };

    reel.updateSymbols = function () {
        // Set symbols
        for (var i = 0; i < reel.configParams.totalAppertureSize; i++) {
            this.symbolSprites[i].symbol.gotoAndStop(this.symbolData[i].symbolId);
        }

        // Move container
        var posOffset = 0;
        var animationStripOffset = 0;
        if (this.spinParams.reverseSpin) {
            posOffset = (((1.0 - this.pos) + reel.configParams.preappertureSymbols) * reel.configParams.appertureSpacing);
            animationStripOffset = (-this.pos * reel.configParams.appertureSpacing);
        } else {
            posOffset = ((this.pos + (reel.configParams.preappertureSymbols - 1)) * reel.configParams.appertureSpacing);
            animationStripOffset = ((this.pos - 1) * reel.configParams.appertureSpacing);
        }

        //Move symbols within clip area
        this.symbolContainer.position.setY(-posOffset);
        this.interactiveSymbolContainer.scale.set(1.0, 1.0);
        // Align animation box and strip with reels
        this.animationBoxContainer.position.set(
            (this.position.x * resourceManager.selectedAssetResolution.scaleFactor),
            (this.position.y * resourceManager.selectedAssetResolution.scaleFactor)
        );
        this.animationBoxContainer.scale.set(this.scale.x, this.scale.y);
        this.animationStripContainer.position.set(
            (((this.position.x * (1.0 / this.scale.x)) + (this.symbolWidth * 0.5)) * resourceManager.selectedAssetResolution.scaleFactor),
            ((this.position.y * (1.0 / this.scale.y)) * resourceManager.selectedAssetResolution.scaleFactor) - animationStripOffset
        );
        //this.animationStripContainer.scale.set(this.scale.x, this.scale.y);

        // Update all symbol position callbacks
        for (var i = 0; i < this.symbolData.length; ++i) {
            var symbolId = this.symbolData[i].symbolId;
            var callbackList = this.symbolPositionCallbacks[symbolId];

            if (callbackList !== undefined) {
                var symbolPosition = {
                    x: (this.symbolContainer.position.x + (this.symbolWidth / 2.0)),
                    y: (this.symbolContainer.position.y + ((i + 0.5) * this.configParams.appertureSpacing))
                };

                for (var j = 0; j < callbackList.length; ++j) {
                    callbackList[j](this.reelIndex, symbolId, symbolPosition);
                }
            }
        }

        // Send out reel spin callback
        for (var i = 0; i < this.reelSpinningCallbacks.length; i++) {
            this.reelSpinningCallbacks[i](this.reelIndex);
        }
    };

    reel.expandAnimationClipRect = function () {
        var offsetX = (this.configParams.animationStripWidth - reel.configParams.viewportWidth) / 2;
        var offsetY = (this.configParams.animationStripHeight - reel.configParams.viewportHeight) / 2;

        reel.mask.clear();
        reel.mask.beginFill(0xFFFF00, 0.5);
        reel.mask.drawRect(-offsetX, -offsetY, this.configParams.animationStripWidth + 1, this.configParams.animationStripHeight + 1);
        reel.mask.endFill();
    };

    reel.restoreAnimationClipRect = function () {
        reel.mask.clear();
        reel.mask.beginFill(0xFFFF00, 0.5);
        reel.mask.drawRect(0, 0, reel.configParams.viewportWidth + 1, reel.configParams.viewportHeight + 1);
        reel.mask.endFill();
    };

    reel.symbolPositionCallbacks = {};
    reel.addSymbolPositionCallback = function (symbolId, callback) {
        if (this.symbolPositionCallbacks[symbolId] === undefined) {
            this.symbolPositionCallbacks[symbolId] = [];
        }

        this.symbolPositionCallbacks[symbolId].push(callback);
    };

    reel.reelSpinningCallbacks = [];
    reel.addReelSpinningCallback = function (callback) {
        this.reelSpinningCallbacks.push(callback);
    };

    reel.getNextSymbolFromInjector = function (injector) {
        // Get the new symbol before we shift the array so that we can apply rules to all current symbols
        var data = injector.getNextSymbol(this.symbolData);

        if (this.spinParams.reverseSpin) {
            this.symbolData.reverse();
            this.symbolSprites.reverse();
        }

        this.clearReelSymbolData(this.configParams.totalAppertureSize - 1);
        var lastBackground = this.symbolSprites[this.configParams.totalAppertureSize - 1].background;
        var lastChildContainer = this.symbolSprites[this.configParams.totalAppertureSize - 1].symbol.childContainer;
        var lastForeground = this.symbolSprites[this.configParams.totalAppertureSize - 1].foreground;

        resourceManager.setParent(lastBackground, this.workingContainer);
        resourceManager.setParent(lastChildContainer, this.workingContainer);
        resourceManager.setParent(lastForeground, this.workingContainer);

        var lastSymbolId = this.symbolData[this.configParams.totalAppertureSize - 1].symbolId;
        if (reel.anySymbolDeletedCallback !== undefined) {
            reel.anySymbolDeletedCallback(this.reelIndex, lastSymbolId, this.configParams.totalAppertureSize - 1);
        }
        if (reel.symbolDeletedCallbacks[lastSymbolId] !== undefined) {
            reel.symbolDeletedCallbacks[lastSymbolId](this.reelIndex, lastSymbolId, this.configParams.totalAppertureSize - 1);
        }

        // Move children down to next index
        for (var i = (this.symbolData.length - 1); i > 0; --i) {
            this.symbolData[i] = this.symbolData[i - 1];

            // Update background
            resourceManager.setParent(this.symbolSprites[i - 1].background, this.symbolSprites[i]);
            this.symbolSprites[i].background = this.symbolSprites[i - 1].background;
            if (this.symbolSprites[i].background !== undefined) {
                this.symbolSprites[i].setChildIndex(this.symbolSprites[i].background, 0);
            }
            // Update childContainer
            resourceManager.setParent(this.symbolSprites[i - 1].symbol.childContainer, this.symbolSprites[i].symbol);
            this.symbolSprites[i].symbol.childContainer = this.symbolSprites[i - 1].symbol.childContainer;
            // Update foreground
            resourceManager.setParent(this.symbolSprites[i - 1].foreground, this.symbolSprites[i]);
            this.symbolSprites[i].foreground = this.symbolSprites[i - 1].foreground;

            // If the symbol is oversized then we need to move it to the front
            if (this.symbolData[i].oversized === true) {
                var symbolId = this.symbolSprites[i].symbol;
                var symbolSprite = this.symbolContainer.children.find(function (element) {
                    return (element.symbol === symbolId);
                });
                this.symbolContainer.setChildIndex(symbolSprite, (this.symbolContainer.children.length - 1));
            }
        }

        // Remove reference to the now redundant children from the last symbol and move to the first symbol
        resourceManager.setParent(lastBackground, this.symbolSprites[0]);
        this.symbolSprites[0].background = lastBackground;
        if (this.symbolSprites[0].background !== undefined) {
            this.symbolSprites[0].setChildIndex(lastBackground, 0);
        }
        resourceManager.setParent(lastChildContainer, this.symbolSprites[0].symbol);
        this.symbolSprites[0].symbol.childContainer = lastChildContainer;
        resourceManager.setParent(lastForeground, this.symbolSprites[0]);
        this.symbolSprites[0].foreground = lastForeground;

        // Create any child objects
        this.setReelSymbolData(0, data);

        var newSymbolId = ((typeof(data) === 'number') ? data : data.symbolId);
        if (reel.anySymbolCreatedCallback !== undefined) {
            reel.anySymbolCreatedCallback(this.reelIndex, newSymbolId,0);
        }
        if (reel.symbolCreatedCallbacks[newSymbolId] !== undefined) {
            reel.symbolCreatedCallbacks[newSymbolId](this.reelIndex, newSymbolId,0);
        }

        if (this.spinParams.reverseSpin) {
            this.symbolData.reverse();
            this.symbolSprites.reverse();
        }

        if (!this.spinParams.renderSymbolsOutOfView) {
            var preClippingIndex = (this.configParams.preappertureSymbols - 1);
            var postClippingIndex = (this.configParams.preappertureSymbols + this.configParams.appertureHeight);
            for (var i = 0; i < this.configParams.totalAppertureSize; ++i) {
                if ((i < preClippingIndex) || (i > postClippingIndex))
                    this.symbolSprites[i].visible = false;
                else
                    this.symbolSprites[i].visible = true;
            }
        }
        return data;
    };

    reel.clearReelSymbolData = function (index) {
        // Remove children from the background
        if (this.configParams.useContainer.background) {
            var background = this.symbolSprites[index].background;
            while (background.children.length > 0) {
                background.removeChild(background.children[0]);
            }
        }
        // Delete child from child contianer
        if (this.configParams.useContainer.child) {
            var children = this.symbolSprites[index].symbol.childContainer.children;
            while (children.length > 0) {
                resourceManager.destroyObject(children[0].name);
            }
        }
        // Remove children from the foreground
        if (this.configParams.useContainer.foreground) {
            var foreground = this.symbolSprites[index].foreground;
            while (foreground.children.length > 0) {
                foreground.removeChild(foreground.children[0]);
            }
        }
    };

    reel.setReelSymbolData = function (index, data) {
        if (typeof(data) === 'number') {
            data = {
                symbolId: data
            };
        } else if (typeof(data) === 'string') {
            data = {
                symbolId: Number(data)
            }
        }

        if (data.childData === undefined) {
            if (this.preInjector !== undefined) {
                data.childData = this.preInjector.getSymbolChildData(data.symbolId);
            }
        }

        var configSymbols = resourceManager.getConfiguration().symbols;
        var configKeys = Object.keys(configSymbols);
        for (var i = 0; i < configKeys.length; ++i) {

            if (configSymbols[configKeys[i]].ID === data.symbolId) {

                var symbolKeys = Object.keys(configSymbols[configKeys[i]]);
                for (var j = 0; j < symbolKeys.length; ++j) {

                    if (data[symbolKeys[j]] === undefined) {
                        data[symbolKeys[j]] = configSymbols[configKeys[i]][symbolKeys[j]];
                    }
                }
            }
        }

        if (data.oversized === undefined)
            data.oversized = false;

        if ((data.childData !== undefined) && (data.childData.length > 0)) {
            for (var i = 0; i < data.childData.length; ++i) {
                resourceManager.createObject(data.childData[i].type, (data.childData[i].name + i), this.symbolSprites[index].symbol.childContainer.name, data.childData[i].json);
            }
        }
        if (data.oversized === true) {
            var symbolId = this.symbolSprites[index].symbol;
            var symbolSprite = this.symbolContainer.children.find(function (element) {
                return (element.symbol === symbolId);
            });
            this.symbolContainer.setChildIndex(symbolSprite, (this.symbolContainer.children.length - 1));
        }

        // Overides data and sets symbol
        this.symbolData[index] = data;
    };

    reel.symbolCreatedCallbacks = {};
    //callback = function(reelIndex, symbolId)
    reel.setAnySymbolCreatedCallback = function (callback) {
        reel.anySymbolCreatedCallback = callback;
    };
    //callback = function(reelIndex, symbolId)
    reel.setSymbolCreatedCallback = function (symbolId, callback) {
        reel.symbolCreatedCallbacks[symbolId] = callback;
    };

    reel.symbolDeletedCallbacks = {};
    //callback = function(reelIndex, symbolId)
    reel.setAnySymbolDeletedCallback = function (callback) {
        reel.anySymbolDeletedCallback = callback;
    };
    //callback = function(reelIndex, symbolId)
    reel.setSymbolDeletedCallback = function (symbolId, callback) {
        reel.symbolDeletedCallbacks[symbolId] = callback;
    };

    reel._getSymbol = function (index) {
        var defaultIndex = ((this.spinParams.reverseSpin) ? (reel.configParams.totalAppertureSize - 1) : 0);
        index = ((index === undefined) ? defaultIndex : index);

        var container = this.symbolContainer.children.find(function (element) {
            return (element.index === index);
        });
        return container;
    };
    reel.getSymbolForegroundContainer = function (index) {
        return this._getSymbol(index).foreground;
    };
    reel.getSymbolContainer = function (index) {
        return this._getSymbol(index).symbol;
    };
    reel.getSymbolChildContainer = function (index) {
        return this._getSymbol(index).symbol.childContainer;
    };
    reel.getSymbolBackgroundContainer = function (index) {
        return this._getSymbol(index).background;
    };

    reel.update = function (delta) {
        this._updateDelta = delta;
        this.Props.stateTime -= delta;
        this.stateMachine.update();
    };
    reel.updatePos = infiniReelTemplate.defaultSpin;
    reel.updateNudge = infiniReelTemplate.nudge;
    reel.updatePopAndDrop = infiniReelTemplate.popAndDrop;

    reel._updateDelta = 0.0;

    StateMachine.Create(reel);
    reel.stateMachine.addState("READY", function state_ready() {
    }.bind(reel));
    reel.stateMachine.addState("PRE_DELAY", function state_predelay() {

        if (this.phase.hold()) {
            if (this.Props.stateTime <= 0) {
                if (this.spinParams.accelerationDistance > 0) {
                    this.updatePos = infiniReelTemplate.accelerationSpin.bind(this);
                    this.stateMachine.switchState("ACCELERATING");
                } else {
                    this.updatePos = infiniReelTemplate.defaultSpin.bind(this);
                    this.stateMachine.switchState("INFINITE_SPIN");
                }

                if (this.configParams.autoUpdateClipRect) {
                    this.restoreAnimationClipRect();
                }
            }
        }
    }.bind(reel));
    reel.stateMachine.addState("ACCELERATING", function state_accelerating() {
        if (this.phase.hold()) {
            if (this.updatePos(this._updateDelta)) {
                this.stateMachine.switchState("INFINITE_SPIN");
                this.updatePos = infiniReelTemplate.defaultSpin.bind(this);
            }

            this.updateSymbols();
        }
    }.bind(reel));
    reel.stateMachine.addState("INFINITE_SPIN", function state_infinitespin() {
        if (this.phase.hold()) {
            this.updatePos(this._updateDelta);
            this.updateSymbols();
        }
    }.bind(reel));
    reel.stateMachine.addState("SPINNING", function state_spinning() {
        if (this.phase.hold()) {
            if (reel.checkSlamStop()) return;

            if (this.updatePos(this._updateDelta)) {
                this.updatePos = infiniReelTemplate.decelerationSpin.bind(this);
                if (this.pos < 1 - this.spinParams.landOffset) {
                    this.pos = 0.99999 - this.spinParams.landOffset;
                }

                this.decelerationPos = (this.spinParams.decelerationDistance + this.pos);

                if (this.spinParams.decelerationDistance > 0) {
                    this.stateMachine.switchState("DECELERATING");
                    this.spinDeceleratingCallback(this.reelIndex);
                } else {
                    this.stateMachine.switchState("JUST_LANDED");
                }
            }
            this.updateSymbols();
        }
    }.bind(reel));
    reel.stateMachine.addState("DECELERATING", function state_decelerating() {
        if (this.phase.hold()) {
            if (reel.checkSlamStop()) return;

            if (this.updatePos(this._updateDelta)) {
                this.pos = 0.99999 - this.spinParams.landOffset;
                this.stateMachine.switchState("JUST_LANDED");
                while (this.postInjector.remainingSymbols > 0) {
                    // Dump any remaining symbols. This may be because the dev has asked for the landOffset to be 0, so it didnt need to bring the symbol above in
                    this.getNextSymbolFromInjector(this.postInjector);
                }
            }
            this.updateSymbols();
        }
    }.bind(reel));
    reel.stateMachine.addState("JUST_LANDED", function state_justlanded() {
        if (this.phase.hold()) {

            if ((Reflex.developerModeData.disableReelLandSound === false) && this.spinParams.landSound) {
                soundManager.play(this.spinParams.landSound);
            }

            this.speedData.currentDecelerationSpeed = this.spinParams.landVelocity;
            this.Props.stateTime = this.spinParams.landAlignTime;

            if (this.spinLandedCallback !== undefined) {
                this.spinLandedCallback(this.reelIndex);
            }

            if (this.spinParams.useBounceAnimation) {
                // Check if any of the symbols in view have a bounce animation
                var symbolTemplate = resourceManager.getConfiguration().symbols;
                for (var i = 0; i < this.configParams.appertureHeight; ++i) {
                    var symbolId = this.symbolData[i + this.configParams.preappertureSymbols].symbolId;
                    var symbolName = Object.keys(symbolTemplate)[symbolId];
                    var template = symbolTemplate[symbolName];

                    if (template.bounceTexture !== undefined) {
                        // Has a bounce animation, play it
                        for (var j = 0; j < this.linkedAnimations.length; ++j) {
                            this.linkedAnimations[j].playAnimation(i, template.bounceTexture);
                        }
                    }
                }
            }

            this.pos = 0.99999 - (this.slamStopRequested ? 0 : this.spinParams.landOffset);
            this.updateSymbols();
            this.stateMachine.switchState((this.spinParams.landOffset === 0 || this.slamStopRequested) ? "SPIN_COMPLETE" : "PULL_BACK");
        }
    }.bind(reel));
    reel.stateMachine.addState("NUDGE", function state_nudge() {
        if (this.phase.hold()) {
            this.updateNudge(this._updateDelta);
            this.updateSymbols();
        }
    }.bind(reel));
    reel.stateMachine.addState("POP_AND_DROP", function state_popanddrop() {
        if (this.phase.enter()) {

        }
        if (this.phase.timed(this.configParams.popAndDropTime)) {
            this.updatePopAndDrop(this.phase.Progress);
        }
        if (this.phase.once()) {
            this.stateMachine.switchState("READY");
        }
        if (this.phase.exit()) {
            this.updatePopAndDrop(1);
            this.updateSymbols();
            this.popAndDropComplete();
        }
    }.bind(reel));

    reel.stateMachine.addState("PULL_BACK", function state_pullback() {
        if (this.phase.hold()) {
            if (this.Props.stateTime <= 0 || this.slamStopRequested) {
                this.pos = 0.999999;
                this.stateMachine.switchState("SPIN_COMPLETE");
            } else {
                var progress = (this.Props.stateTime / this.spinParams.landAlignTime);
                this.pos = (0.99999 - (progress * this.spinParams.landOffset));
            }

            this.updateSymbols();
        }
    }.bind(reel));
    reel.stateMachine.addState("NUDGE_PULL_BACK", function state_nudgepullback() {
        if (this.phase.hold()) {
            if (this.Props.stateTime <= 0) {
                this.pos = 0.999999;
                this.stateMachine.switchState("READY");
                this.nudgeOnComplete();
            } else {
                var progress = (this.Props.stateTime / this.spinParams.landAlignTime);
                this.pos = (0.99999 - (progress * this.spinParams.landOffset));
            }

            this.updateSymbols();
        }
    }.bind(reel));
    reel.stateMachine.addState("SPIN_COMPLETE", function state_spincomplete() {
        if (this.phase.hold()) {
            // Reel landed
            this.pos = 0.999999;
            this.updateSymbols();

            var spinComplete = true;
            for (var i = 0; i < this.linkedAnimations.length; ++i) {
                for (var j = 0; j < this.configParams.appertureHeight; ++j) {
                    if (this.linkedAnimations[i].isAnimationPlaying(j)) {
                        spinComplete = this.linkedAnimations[i].reelAnimations[j].loop;
                        break;
                    } else {
                        this.linkedAnimations[i].hideAnimation(j);
                    }
                }
            }

            if (gdk.deviceInfo.msie !== undefined && Reflex.developerModeData.disableReelLandSound === false && this.spinParams.landSound) {
                soundManager.stop(this.spinParams.landSound);
            }

            // All animations have completed so the spin is now complete
            this.stateMachine.switchState("READY");
            this.spinning = false;
            this.spinCompleteCallback(this.reelIndex);
        }
    }.bind(reel));

    reel.stateMachine.switchState("READY");
    return reel;
};